import React from "react";
import { SnackbarProvider } from "notistack";
import { SchoolLinkRouting } from "./SchoolLinkRouting";
import { Fonts, FontFamilies } from "theme/fontConfig";
export const SchoolLink = () => {
  return (
    <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={4000}
      style={{ fontFamily: FontFamilies.General, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
    >
      <SchoolLinkRouting />
    </SnackbarProvider>
  );
};
